import React from 'react';

export const WisconsinInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">State of Wisconsin</p>
        <p className="eds-l-mar-bot-1">
            <strong>Small Business 20/20 program</strong> |&nbsp;
            <a
                href="https://www.apg-wi.com/sawyer_county_record/free/wedc-offers-grants-to-small-businesses-suffering-losses-due-to/article_cea3c5a4-6932-11ea-97b0-27ce138d59d0.html"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            $5 million program run by the Wisconsin Economic Development
            Corporation which offers up to $20,000 in grants to targeted
            borrowers throughout the state.
        </p>
    </div>
);
